import { post } from "../../service/api";

const SetMerchantPermission = async (merchantId, permissionId) => {
  try {
    const response = await post(
      `/merchant/${merchantId}/permissions/${permissionId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error SetMerchantPermission:", error);
    throw error;
  }
};

export default SetMerchantPermission;
